import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { NutritionProfileFragment } from "../gql/generated/graphqlSchema.tsx";
import { formatNutritionDeclaration } from "../utils/nutritionFormat.ts";

export const NutritionDeclaration = ({
  nutritionProfile,
}: {
  readonly nutritionProfile: NutritionProfileFragment | null | undefined;
}) => {
  const { t, i18n } = useTranslation();
  const declaration = formatNutritionDeclaration(nutritionProfile, i18n.language, t);
  if (declaration == null) return null;
  return (
    <Typography.Text>
      <strong>{declaration.header}</strong> {declaration.body}
    </Typography.Text>
  );
};
